import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
  LogoAgderPrimaerBokmaalNegativPdf,
  LogoAgderPrimaerBokmaalNegativPng,
  LogoAgderPrimaerBokmaalNegativSvg,
  LogoAgderPrimaerBokmaalPositivPdf,
  LogoAgderPrimaerBokmaalPositivPng,
  LogoAgderPrimaerBokmaalPositivSvg,
  LogoAgderPrimaerBokmaalEngelskNegativPdf,
  LogoAgderPrimaerBokmaalEngelskNegativPng,
  LogoAgderPrimaerBokmaalEngelskNegativSvg,
  LogoAgderPrimaerBokmaalEngelskPositivPdf,
  LogoAgderPrimaerBokmaalEngelskPositivPng,
  LogoAgderPrimaerBokmaalEngelskPositivSvg,
  LogoAgderPrimaerNynorskNegativPdf,
  LogoAgderPrimaerNynorskNegativPng,
  LogoAgderPrimaerNynorskNegativSvg,
  LogoAgderPrimaerNynorskPositivPdf,
  LogoAgderPrimaerNynorskPositivPng,
  LogoAgderPrimaerNynorskPositivSvg,
  LogoAgderPrimaerNynorskEngelskNegativPdf,
  LogoAgderPrimaerNynorskEngelskNegativPng,
  LogoAgderPrimaerNynorskEngelskNegativSvg,
  LogoAgderPrimaerNynorskEngelskPositivPdf,
  LogoAgderPrimaerNynorskEngelskPositivPng,
  LogoAgderPrimaerNynorskEngelskPositivSvg,
  LogoAgderSekundaerBokmaalNegativPdf,
  LogoAgderSekundaerBokmaalNegativPng,
  LogoAgderSekundaerBokmaalNegativSvg,
  LogoAgderSekundaerBokmaalPositivPdf,
  LogoAgderSekundaerBokmaalPositivPng,
  LogoAgderSekundaerBokmaalPositivSvg,
  LogoAgderSekundaerBokmaalEngelskNegativPdf,
  LogoAgderSekundaerBokmaalEngelskNegativPng,
  LogoAgderSekundaerBokmaalEngelskNegativSvg,
  LogoAgderSekundaerBokmaalEngelskPositivPdf,
  LogoAgderSekundaerBokmaalEngelskPositivPng,
  LogoAgderSekundaerBokmaalEngelskPositivSvg,
  LogoAgderSekundaerNynorskNegativPdf,
  LogoAgderSekundaerNynorskNegativPng,
  LogoAgderSekundaerNynorskNegativSvg,
  LogoAgderSekundaerNynorskPositivPdf,
  LogoAgderSekundaerNynorskPositivPng,
  LogoAgderSekundaerNynorskPositivSvg,
  LogoAgderSekundaerNynorskEngelskNegativPdf,
  LogoAgderSekundaerNynorskEngelskNegativPng,
  LogoAgderSekundaerNynorskEngelskNegativSvg,
  LogoAgderSekundaerNynorskEngelskPositivPdf,
  LogoAgderSekundaerNynorskEngelskPositivPng,
  LogoAgderSekundaerNynorskEngelskPositivSvg,
  LogoAgderSentrertBokmaalNegativPdf,
  LogoAgderSentrertBokmaalNegativPng,
  LogoAgderSentrertBokmaalNegativSvg,
  LogoAgderSentrertBokmaalPositivPdf,
  LogoAgderSentrertBokmaalPositivPng,
  LogoAgderSentrertBokmaalPositivSvg,
  LogoAgderSentrertBokmaalEngelskNegativPdf,
  LogoAgderSentrertBokmaalEngelskNegativPng,
  LogoAgderSentrertBokmaalEngelskNegativSvg,
  LogoAgderSentrertBokmaalEngelskPositivPdf,
  LogoAgderSentrertBokmaalEngelskPositivPng,
  LogoAgderSentrertBokmaalEngelskPositivSvg,
  LogoAgderSentrertNynorskNegativPdf,
  LogoAgderSentrertNynorskNegativPng,
  LogoAgderSentrertNynorskNegativSvg,
  LogoAgderSentrertNynorskPositivPdf,
  LogoAgderSentrertNynorskPositivPng,
  LogoAgderSentrertNynorskPositivSvg,
  LogoAgderSentrertNynorskEngelskNegativPdf,
  LogoAgderSentrertNynorskEngelskNegativPng,
  LogoAgderSentrertNynorskEngelskNegativSvg,
  LogoAgderSentrertNynorskEngelskPositivPdf,
  LogoAgderSentrertNynorskEngelskPositivPng,
  LogoAgderSentrertNynorskEngelskPositivSvg,
} from "../../assets/logo/Agder/exportAgder.js";

export default function AgderPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logofiler for Statsforvalteren i Agder"
          lead="Alle logoer for Agder i ulike variasjoner og filformater"
          breadcrumbText="Tilbake til logo"
          breadcrumbUrl="/logo"
        />
        <main>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <p>Tekst om logovarianter og filformater...</p>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Primærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoAgderPrimaerBokmaalPositivSvg}
                    title="Primærlogo: Statsforvalteren i Agder, bokmål"
                    text="Bokmål"
                    blackSvg={LogoAgderPrimaerBokmaalPositivSvg}
                    blackPng={LogoAgderPrimaerBokmaalPositivPng}
                    blackPdf={LogoAgderPrimaerBokmaalPositivPdf}
                    whiteSvg={LogoAgderPrimaerBokmaalNegativSvg}
                    whitePng={LogoAgderPrimaerBokmaalNegativPng}
                    whitePdf={LogoAgderPrimaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderPrimaerBokmaalEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Agder, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoAgderPrimaerBokmaalEngelskPositivSvg}
                    blackPng={LogoAgderPrimaerBokmaalEngelskPositivPng}
                    blackPdf={LogoAgderPrimaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoAgderPrimaerBokmaalEngelskNegativSvg}
                    whitePng={LogoAgderPrimaerBokmaalEngelskNegativPng}
                    whitePdf={LogoAgderPrimaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderPrimaerNynorskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Agder, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoAgderPrimaerNynorskPositivSvg}
                    blackPng={LogoAgderPrimaerNynorskPositivPng}
                    blackPdf={LogoAgderPrimaerNynorskPositivPdf}
                    whiteSvg={LogoAgderPrimaerNynorskNegativSvg}
                    whitePng={LogoAgderPrimaerNynorskNegativPng}
                    whitePdf={LogoAgderPrimaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderPrimaerNynorskEngelskPositivSvg}
                    title="Primærlogo: Statsforvalteren i Agder, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoAgderPrimaerNynorskEngelskPositivSvg}
                    blackPng={LogoAgderPrimaerNynorskEngelskPositivPng}
                    blackPdf={LogoAgderPrimaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoAgderPrimaerNynorskEngelskNegativSvg}
                    whitePng={LogoAgderPrimaerNynorskEngelskNegativPng}
                    whitePdf={LogoAgderPrimaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sekundærlogo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoAgderSekundaerBokmaalPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Agder, bokmål"
                    text="Bokmål"
                    blackSvg={LogoAgderSekundaerBokmaalPositivSvg}
                    blackPng={LogoAgderSekundaerBokmaalPositivPng}
                    blackPdf={LogoAgderSekundaerBokmaalPositivPdf}
                    whiteSvg={LogoAgderSekundaerBokmaalNegativSvg}
                    whitePng={LogoAgderSekundaerBokmaalNegativPng}
                    whitePdf={LogoAgderSekundaerBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderSekundaerBokmaalEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Agder, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoAgderSekundaerBokmaalEngelskPositivSvg}
                    blackPng={LogoAgderSekundaerBokmaalEngelskPositivPng}
                    blackPdf={LogoAgderSekundaerBokmaalEngelskPositivPdf}
                    whiteSvg={LogoAgderSekundaerBokmaalEngelskNegativSvg}
                    whitePng={LogoAgderSekundaerBokmaalEngelskNegativPng}
                    whitePdf={LogoAgderSekundaerBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderSekundaerNynorskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Agder, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoAgderSekundaerNynorskPositivSvg}
                    blackPng={LogoAgderSekundaerNynorskPositivPng}
                    blackPdf={LogoAgderSekundaerNynorskPositivPdf}
                    whiteSvg={LogoAgderSekundaerNynorskNegativSvg}
                    whitePng={LogoAgderSekundaerNynorskNegativPng}
                    whitePdf={LogoAgderSekundaerNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderSekundaerNynorskEngelskPositivSvg}
                    title="Sekundærlogo: Statsforvalteren i Agder, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoAgderSekundaerNynorskEngelskPositivSvg}
                    blackPng={LogoAgderSekundaerNynorskEngelskPositivPng}
                    blackPdf={LogoAgderSekundaerNynorskEngelskPositivPdf}
                    whiteSvg={LogoAgderSekundaerNynorskEngelskNegativSvg}
                    whitePng={LogoAgderSekundaerNynorskEngelskNegativPng}
                    whitePdf={LogoAgderSekundaerNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col>
              <h4>Sentert logo</h4>
              <Table responsive size="lg" className="table-simple">
                <LogoTableHead />
                <tbody>
                  <LogoTableRow
                    logoUrl={LogoAgderSentrertBokmaalPositivSvg}
                    title="Sentert logo: Statsforvalteren i Agder, bokmål"
                    text="Bokmål"
                    blackSvg={LogoAgderSentrertBokmaalPositivSvg}
                    blackPng={LogoAgderSentrertBokmaalPositivPng}
                    blackPdf={LogoAgderSentrertBokmaalPositivPdf}
                    whiteSvg={LogoAgderSentrertBokmaalNegativSvg}
                    whitePng={LogoAgderSentrertBokmaalNegativPng}
                    whitePdf={LogoAgderSentrertBokmaalNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderSentrertBokmaalEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Agder, bokmål + engelsk"
                    text="Bokmål + engelsk"
                    blackSvg={LogoAgderSentrertBokmaalEngelskPositivSvg}
                    blackPng={LogoAgderSentrertBokmaalEngelskPositivPng}
                    blackPdf={LogoAgderSentrertBokmaalEngelskPositivPdf}
                    whiteSvg={LogoAgderSentrertBokmaalEngelskNegativSvg}
                    whitePng={LogoAgderSentrertBokmaalEngelskNegativPng}
                    whitePdf={LogoAgderSentrertBokmaalEngelskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderSentrertNynorskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Agder, nynorsk"
                    text="Nynorsk"
                    blackSvg={LogoAgderSentrertNynorskPositivSvg}
                    blackPng={LogoAgderSentrertNynorskPositivPng}
                    blackPdf={LogoAgderSentrertNynorskPositivPdf}
                    whiteSvg={LogoAgderSentrertNynorskNegativSvg}
                    whitePng={LogoAgderSentrertNynorskNegativPng}
                    whitePdf={LogoAgderSentrertNynorskNegativPdf}
                  />
                  <LogoTableRow
                    logoUrl={LogoAgderSentrertNynorskEngelskPositivSvg}
                    title="Sentert logo: Statsforvalteren i Agder, nynorsk + engelsk"
                    text="Nynorsk + engelsk"
                    blackSvg={LogoAgderSentrertNynorskEngelskPositivSvg}
                    blackPng={LogoAgderSentrertNynorskEngelskPositivPng}
                    blackPdf={LogoAgderSentrertNynorskEngelskPositivPdf}
                    whiteSvg={LogoAgderSentrertNynorskEngelskNegativSvg}
                    whitePng={LogoAgderSentrertNynorskEngelskNegativPng}
                    whitePdf={LogoAgderSentrertNynorskEngelskNegativPdf}
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
